import { useEffect, useSyncExternalStore } from 'react';
import { docenteApi } from '../api/docenteApi';
import { aplicarNombreColegio, NOMBRE_COLEGIO_ACTUALIZADO } from '../utils/nombreColegio';
import { aplicarCredencialDocente } from '../utils/credencialDocente';

const pendientes = new Map();
const leer = () => localStorage.getItem('nombre_colegio') || 'Mi Institución';
const escuchar = (callback) => {
  window.addEventListener(NOMBRE_COLEGIO_ACTUALIZADO, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(NOMBRE_COLEGIO_ACTUALIZADO, callback);
    window.removeEventListener('storage', callback);
  };
};
export const useNombreColegio = () => useSyncExternalStore(escuchar, leer, () => 'Mi Institución');

async function refrescar() {
  const token = localStorage.getItem('docente_token');
  const colegioID = localStorage.getItem('colegio_seleccionado');
  if (!token || !colegioID) return;
  const clave = JSON.stringify([token, colegioID]);
  if (pendientes.has(clave)) return pendientes.get(clave);
  const peticion = (async () => {
    try {
      const respuesta = await docenteApi.verificarToken();
      aplicarCredencialDocente(respuesta, token, colegioID);
      if (aplicarNombreColegio(respuesta, token, colegioID)) {
        window.dispatchEvent(new Event(NOMBRE_COLEGIO_ACTUALIZADO));
      }
    } catch { /* Fallo de red: conservar sesión y último nombre conocido. */ }
    finally { pendientes.delete(clave); }
  })();
  pendientes.set(clave, peticion);
  return peticion;
}

export function useRefrescarNombreColegio(ruta) {
  useEffect(() => {
    const alVolver = () => { if (document.visibilityState === 'visible') void refrescar(); };
    void refrescar();
    window.addEventListener('focus', alVolver);
    document.addEventListener('visibilitychange', alVolver);
    return () => {
      window.removeEventListener('focus', alVolver);
      document.removeEventListener('visibilitychange', alVolver);
    };
  }, [ruta]);
}
